import { render } from "./AuthForgotPasswordLink.vue?vue&type=template&id=3adfbd93&scoped=true"
const script = {}

import "./AuthForgotPasswordLink.vue?vue&type=style&index=0&id=3adfbd93&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3adfbd93"

export default script